const STATE_KEY = "liverun_dev_mode";

export default {
  /**
   * Updates the persisted dev mode state based on the current query parameters.
   * Should be called on application initialization and route changes.
   * @param {Object} query - The route query object
   */
  updateState(query) {
    if (!query) return;

    if (query.dev === "1" || query.debug === "1") {
      localStorage.setItem(STATE_KEY, "true");
    } else if (query.dev === "0" || query.debug === "0") {
      localStorage.setItem(STATE_KEY, "false");
    }
  },

  /**
   * Checks if dev mode is enabled.
   * Priority:
   * 1. Query parameter ?dev=0 or ?debug=0 (Force Disable)
   * 2. Query parameter ?dev=1 or ?debug=1 (Force Enable)
   * 3. LocalStorage
   *
   * @param {Object} [query] - The current route query object
   * @returns {boolean}
   */
  isEnabled(query) {
    // If specific disable flag is present in query, return false immediately (override storage)
    if (query && (query.dev === "0" || query.debug === "0")) {
      return false;
    }

    // If specific enable flag is present, return true
    if (query && (query.dev === "1" || query.debug === "1")) {
      return true;
    }

    // Fallback to storage
    return localStorage.getItem(STATE_KEY) === "true";
  },
};



// WEBPACK FOOTER //
// ./src/services/DevModeService.js